export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch {
    // ignore write errors
  }
};

/**
 * Get storage key for a specific account
 */
export const getAccountStorageKey = (accountId: string): string => {
  return `markit_account_${accountId}`;
};

/**
 * Save account data to localStorage
 */
export const saveAccountData = (accountId: string): void => {
  try {
    const key = getAccountStorageKey(accountId);
    const serializedData = JSON.stringify(accountId);
    localStorage.setItem(key, serializedData);
  } catch (error) {
    console.error(`Error saving account data for ${accountId}:`, error);
  }
};

/**
 * Remove account data from localStorage
 */
export const removeAccountData = (accountId: string): void => {
  try {
    const key = getAccountStorageKey(accountId);
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing account data for ${accountId}:`, error);
  }
};

/**
 * Get all stored account IDs
 */
export const getStoredAccountIds = (): string[] => {
  try {
    const accountIds: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("markit_account_")) {
        const accountId = key.replace("markit_account_", "");
        accountIds.push(accountId);
      }
    }
    return accountIds;
  } catch (error) {
    console.error("Error getting stored account IDs:", error);
    return [];
  }
};
